var map = {
	"./birka.png": "e2af",
	"./bracelet.png": "cc99",
	"./keys.png": "586d",
	"./paket-2.png": "dd02",
	"./paket-3.png": "6655",
	"./paket.png": "2f0c",
	"./passport.png": "4d6d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3360";